import {
  ProductMaster_MASSIVE_UPLOAD_SET_ALLOW_UPLOAD,
  ProductMaster_MASSIVE_UPLOAD_CLEAR_ALLOW_UPLOAD,
  ProductMaster_MASSIVE_UPLOAD_REQUEST_VERIFY,
  ProductMaster_MASSIVE_UPLOAD_SET_VERIFY,
  ProductMaster_MASSIVE_UPLOAD_CLEAR_VERIFY,
  ProductMaster_MASSIVE_UPLOAD_REQUEST_UPLOAD,
  ProductMaster_MASSIVE_UPLOAD_SET_UPLOAD,
  ProductMaster_MASSIVE_UPLOAD_CLEAR_UPLOAD,
} from '../actions';

function ProductMasterMassiveUploadReducer(state = {}, action) {
  const { type } = action;

  switch (type) {
    case ProductMaster_MASSIVE_UPLOAD_SET_ALLOW_UPLOAD:
      return {
        ...state,
        isLoading: false,
        allowUpload: action.payload,
      };

    case ProductMaster_MASSIVE_UPLOAD_CLEAR_ALLOW_UPLOAD:
      return {
        ...state,
        isLoading: false,
        allowUpload: null,
      };

    case ProductMaster_MASSIVE_UPLOAD_REQUEST_VERIFY:
      return {
        ...state,
        isLoading: true,
        verify: null,
      };

    case ProductMaster_MASSIVE_UPLOAD_SET_VERIFY:
      return {
        ...state,
        isLoading: false,
        verify: action.payload,
      };

    case ProductMaster_MASSIVE_UPLOAD_CLEAR_VERIFY:
      return {
        ...state,
        isLoading: false,
        verify: null,
      };

    case ProductMaster_MASSIVE_UPLOAD_REQUEST_UPLOAD:
      return {
        ...state,
        isLoading: true,
        upload: null,
      };

    case ProductMaster_MASSIVE_UPLOAD_SET_UPLOAD:
      return {
        ...state,
        isLoading: false,
        upload: action.payload,
      };

    case ProductMaster_MASSIVE_UPLOAD_CLEAR_UPLOAD:
      return {
        ...state,
        isLoading: false,
        upload: null,
      };

    default:
      return state;
  }
}

export default ProductMasterMassiveUploadReducer;
